
import Vue, { PropType } from 'vue';

export interface Crumb {
    text: string;
    to?: string;
    exact?: boolean;
    active?: boolean;

    link?: boolean;
    href?: string;
}

export default Vue.extend({
    name: 'Breadcrumb',
    props: {
        trace: {
            type: Array as PropType<Crumb[]>,
            required: true,
        },
        light: {
            type: Boolean,
            default: false,
        },
    },
});
